import PratusLogo from './assets/images/pratus__logo.svg';
import PratusLogoIcon from './assets/images/pratus__logoIcon.svg?no-inline'; // No Inline so this icon can be referenced by Auth0 statically.
import { User } from '@auth0/auth0-react';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { useEffect, useState } from 'react';
import EmailVerificationDialog from 'components/Auth/EmailVerificationDialog';
import UserAuthorizationFailedDialog from 'components/Auth/UserAuthorizationFailedDialog';
import { useBrowserAuth } from './providers/BrowserAuthProvider';

type LoginPageProps = {
  isUsingTeams: boolean;
  user?: User;
  error?: unknown;
};

export function LoginPageButton({
  isUsingTeams = false,
  user,
  error,
}: LoginPageProps) {
  const { authProvider, login } = useBrowserAuth();

  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [showEmailConfirmDialog, setShowEmailConfirmDialog] = useState(false);

  useEffect(() => {
    if (error) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowErrorDialog(true);
    }

    const userAuthProvider = user?.sub?.split('|')[0];

    if (
      authProvider === 'auth0' &&
      user &&
      !user.email_verified &&
      userAuthProvider === 'auth0'
    ) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowEmailConfirmDialog(true);
    }
  }, [authProvider, error, user]);

  return (
    <>
      <div className="site-authentication">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="site-authentication__logo mb-5">
                <img className="d-none d-md-flex" src={PratusLogo} alt="" />
                <img className="d-flex d-md-none" src={PratusLogoIcon} alt="" />
              </div>
              <div className="row justify-content-center">
                <div className="col-md-10 col-lg-10 col-xl-6">
                  <p className="m-0">
                    To connect with the Disastertech team, visit <br />
                    <a
                      href="https://www.disastertech.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://www.disastertech.com
                    </a>
                  </p>
                </div>
              </div>
              <div className="button-group d-block d-md-flex justify-content-center mt-5">
                {isUsingTeams === false ? (
                  <StylishNewButton
                    className="button--primary w-100 w-md-auto mt-3 mt-md-0 ms-0 ms-md-3"
                    onClick={() => {
                      void login();
                    }}
                  >
                    Log into PRATUS
                  </StylishNewButton>
                ) : null}
              </div>
              <p className="mt-4 mb-0">
                By entering, you consent to our{' '}
                <a href="/privacy.html" target="_blank">
                  Privacy Policy
                </a>{' '}
                and{' '}
                <a href="/tos.html" target="_blank">
                  Terms of Service
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
      {showEmailConfirmDialog ? (
        <EmailVerificationDialog
          user={user}
          show={showEmailConfirmDialog}
          onClose={() => setShowEmailConfirmDialog(false)}
        />
      ) : null}
      {showErrorDialog ? (
        <UserAuthorizationFailedDialog
          show={showErrorDialog}
          onClose={() => setShowErrorDialog(false)}
        />
      ) : null}
    </>
  );
}
